import React, { useEffect, useRef, useState } from "react";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  ChevronUp,
  Box,
  FileText,
  Filter,
  PlusCircle,
  RotateCcw,
  Sliders,
  List,
  User,
  Calendar,
} from "feather-icons-react/build/IconComponents";


import Select from "react-select";
import { Table } from "antd";
import { setheadertoggle } from "../../redux/toggle";
import { useDispatch, useSelector } from "react-redux";
import { getAllAccountType, getPayInOutReport } from "../../services/ReportApiService";
import {
  DatatablePagingParameter,
  Filterclass,
} from "../../core/json/DatatablePagingParameters";
import { renderTooltip } from "../../redux/helper";
import { Checkbox } from "antd";
import { DatePicker } from "antd";
// import "react-datepicker/dist/react-datepicker.css";
import dayjs from "dayjs";
import { isValidDateRange } from "./salesReportDateRange";

import {
  exportExcel,
  exportPDF,
  printReport,
} from "../../core/utils/StockReportUtils";
import LoadingUtils from "../../core/utils/LoadingUtils";
import { data } from "jquery";
  
const TypeFilter = [
    { value: 0, label: "Pay In" },
    { value: 1, label: "Pay Out" },
  ];

  
  console.log(TypeFilter,"Type")
const PayInOutReport = () => {
  const [typeFilter, setTypeFilter] = useState(null);
  const [acctypeFilter, setaccTypeFilter] = useState(null);
 const [AcctypeFilter, setAccTypeFilter] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [stockData, setstockData] = useState();
  const [footerTotals, setFooterTotal] = useState();
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [loading, setloading] = useState(false);
  const [fromDate, setFromDate] = useState(dayjs());
  const [toDate, setToDate] = useState(dayjs());
  const [totalcount, settotalcount] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const title = "Pay In / Out Reports";
  const dispatch = useDispatch();
  const { branch } = useSelector((state) => state.branchlist);
  const { togglehead } = useSelector((state) => state.headerToggle);
  const tableRef = useRef(null);

  const [decimalpoints, setDecimalPoints] = useState(2);
    const {
     
      settingList,
   
    } = useSelector((state) => state.usersetting);
    useEffect(() => {
        
        const match = settingList?.currencyFormat?.toString()?.match(/\.0+/);
            const currfmt = match ? match[0]?.length - 1 : 0;
            setDecimalPoints(currfmt);
            console.log("Enter")
            handleStockInfullReport();
            handleAccountType();
      }, [branch, fromDate, toDate]);

 const handleStockInReport = async (page, size) => {
    if (!isValidDateRange(fromDate, toDate)) return;
    const DatatablePagingParameters = new DatatablePagingParameter();
    DatatablePagingParameters.PageNumber = 1;
    DatatablePagingParameters.PageSize = -1;
    const formattedfromDate = dayjs(fromDate).format("YYYY-MM-DD");
    const formattedtoDate = dayjs(toDate).format("YYYY-MM-DD");
    const Filters = new Filterclass();
    Filters.Branch = branch;
    Filters.FromDate = formattedfromDate;
    Filters.ToDate = formattedtoDate;
    try {
      const response = await getPayInOutReport({
        DatatablePagingParameters,
        Filters,
      });
      setstockData(response?.data?.payInOutReportDetail);
      setFilteredData(stockData);
      setFooterTotal(stockData?.reduce((sum, record) => sum + record.amount, 0));
      settotalcount(stockData?.length);
    } catch (error) {
      console.error(
        "Error Fetching Account Type!",
        error?.response?.data?.Message
      );
    }
  };
  const handleStockInfullReport = async () => {
    if (!isValidDateRange(fromDate, toDate)) return;
    setloading(true);
    const DatatablePagingParameters = new DatatablePagingParameter();
    DatatablePagingParameters.PageNumber = 1;
    DatatablePagingParameters.PageSize = -1;
    const formattedfromDate = dayjs(fromDate).format("YYYY-MM-DD");
    const formattedtoDate = dayjs(toDate).format("YYYY-MM-DD");
    const Filters = new Filterclass();
    Filters.Branch = branch;
    Filters.FromDate = formattedfromDate;
    Filters.ToDate = formattedtoDate;
    // Pay In / Pay Out is filtered in the browser; always send the key ("" = all, G-8)
    Filters.Type = "";

    try {
      const response = await getPayInOutReport({
        DatatablePagingParameters,
        Filters,
      });

      setstockData(response?.data?.payInOutReportDetail);
      setFilteredData(response?.data?.payInOutReportDetail);
      const totalCount = 0;
      setFooterTotal(response?.data?.payInOutReportDetail?.reduce((sum, record) => sum + record.amount, 0));
      // Set the total count
      settotalcount(response?.data?.payInOutReportDetail?.length);
      setloading(false);
    } catch (error) {
      console.error(
        "Error Fetching Account Type!",
        error?.response?.data?.Message
      );
      setloading(false);
    }
  };

const handleAccountType = async () => {
    try {
      const response = await getAllAccountType();
      const options = response.data.map((item) => ({
        value: item.id,       // or whatever ID field exists
        label: item.name,
      }));
      setAccTypeFilter(options);
    } catch (error) {
      console.error(
        "Error Fetching Account Type!",
        error?.response?.data?.Message
      );
      setloading(false);
    }
  };

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };
 const [filteredData, setFilteredData] = useState(stockData); // Start with full data
  const menuItems = [
    { value: "1", label: "DATE", checked: true },
    { value: "2", label: "Account Name", checked: true },
    { value: "3", label: "Amount", checked: true },
    { value: "4", label: "Type", checked: true },
    { value: "5", label: "Narration", checked: true },
    
  ];

  const columns = [
    {
      title: "Date",
      key: "1",
      dataIndex: "date",
      render: (text) => {
        const formatDate = (dateString) => {
          const date = new Date(dateString);
          return date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          });
        };

        return <span>{formatDate(text)}</span>;
      },
      sorter: (a, b) => a.billDate - b.billDate,
    },
    { 
      title: 'Account Name',
      dataIndex: ['accountType', 'name'], // Correct way to access nested object
      key: '2',
      render: (_, record) => record?.accountType?.name
    },
    {
      title: "Amount",
      key: "3",
      dataIndex: "amount",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Type",
      key: "4",
      dataIndex: "isPayIn",
      render: (value) => (value === 1 ? 'Pay Out' : 'Pay In'), // conversion here,
    },
    {
      title: "Narration",
      key: "5",
      dataIndex: "narration",
      render: (text) => <span>{text}</span>,
    },
    
  ];

  const [selectedColumns, setSelectedColumns] = useState([]);

  useEffect(() => {
    // Set default selected columns based on menuItems' checked status
    const initialSelectedColumns = menuItems
      ?.filter((item) => item.checked)
      .map((item) => columns.find((col) => col.key === item.value));

    setSelectedColumns(initialSelectedColumns);
  }, []);

  const handleCheckboxChange = (columnKey, checked) => {
    if (checked) {
      // Add column if checkbox is checked
      setSelectedColumns((prevColumns) => {
        const updatedColumns = [
          ...prevColumns,
          columns.find((col) => col.key === columnKey),
        ];

        // Sort the array by col.key in ascending order
        return updatedColumns.sort((a, b) => (a.key > b.key ? 1 : -1));
      });
    } else {
      // Remove column if checkbox is unchecked
      setSelectedColumns((prevColumns) =>
        prevColumns?.filter((col) => col.key !== columnKey)
      );
    }
  };

  const handletogglehead = () => {
    dispatch(setheadertoggle(!togglehead));
  };
  const handleFromDateChange = (date) => {
    console.log(date, "from date");
    setFromDate(date);

    setToDate(null); // reset to date when from date changes
  };
  const handleToDateChange = (date) => {
    setToDate(date);
    console.log(date, "to date");
  };
  const getActiveTabData = () => {
    let fieldMapping = {};

    // Function to create the field mapping between column titles and dataIndex values
    const createfieldMapping = (columns) => {
      const mappings = {};
      columns.forEach((col) => {
        if(col.title === "Account Name")
        {mappings[col.title] = "accountName"}
        else{
          mappings[col.title] = col.dataIndex; // Map title to dataIndex
        }
      });
      return mappings;
    };
      // Transform data to map isPayIn: 0/1 => "Pay In"/"Pay Out"
    const transformedData = filteredData?.map((item) => ({
    ...item,
    isPayIn: item.isPayIn === 1 ? "Pay Out" : "Pay In",
    accountName: item?.accountType?.name || "",
    
    }));

    
    // Generate the field mapping for the current columns
    fieldMapping = createfieldMapping(columns);

    // Return the filtered data, columns, and field mapping
    return { data: transformedData , columns: selectedColumns,Rname:"Pay In/Out Report", fieldMapping };
  };
  const handleSearchbtn = async () => {
  await handleStockInfullReport(); // Ensure data is fetched fresh
  applyFilters(acctypeFilter?.label, typeFilter); // Apply current filters
};

const applyFilters = (search = "", type = null) => {
  let filtered = stockData;

  if (type) {
    filtered = filtered.filter(item => item.isPayIn === type.value);
  }
    filtered = filtered.filter(item => item.accountType?.name?.toLowerCase().includes(search.toLowerCase()));
  if (search.trim() !== "") {
    const lowerSearch = search.toLowerCase();
    filtered = filtered.filter(item =>
      Object.values(item).some(value => {
        if (typeof value === "object" && value !== null) {
          return Object.values(value).some(nestedVal =>
            String(nestedVal).toLowerCase().includes(lowerSearch)
          );
        }
        return String(value).toLowerCase().includes(lowerSearch);
      })
    );
  }

  setFilteredData(filtered);
  setFooterTotal(filtered.reduce((sum, item) => sum + item.amount, 0));
};
const handleFilterChange = (selectedOption) => {
    setTypeFilter(selectedOption);
    var filtered = stockData;
    if (!selectedOption) {
      // Show all if cleared
      setFilteredData(stockData);
      if (acctypeFilter !== null && acctypeFilter !== undefined) {
         filtered = filtered.filter(item => item.accountType?.name?.toLowerCase().includes(acctypeFilter.label.toLowerCase()));
       }
    } else {
      // Filter by selected type
        if (acctypeFilter !== null && acctypeFilter !== undefined) {
         filtered = filtered.filter(item => item.accountType?.name?.toLowerCase().includes(acctypeFilter.label.toLowerCase()));
        }
        console.log(selectedOption.value,"selectedoption")
        filtered = filtered.filter(item => item.isPayIn === selectedOption.value);
       
        
    }
     setFilteredData(filtered);
    setFooterTotal(filtered?.reduce((sum, record) => sum + record.amount, 0));
  
  };
const handleAccFilterChange = (selectedOption) => {
    setaccTypeFilter(selectedOption);
    var filtered = stockData;
    if (!selectedOption) {
      // Show all if cleared
      setFilteredData(stockData);
      if (typeFilter !== null && typeFilter !== undefined) {
         filtered = filtered.filter(item => item.isPayIn === typeFilter.value);
        }
    } else {
      // Filter by selected type
      console.log(typeFilter, "filter")
      if (typeFilter !== null && typeFilter !== undefined) {
         filtered = filtered.filter(item => item.isPayIn === typeFilter.value);
        }
        console.log(filtered,"AFTER TYPE")
        filtered = filtered.filter(item => item.accountType?.name?.toLowerCase().includes(selectedOption.label.toLowerCase()));
        
        
    }
    setFilteredData(filtered);
    setFooterTotal(filtered?.reduce((sum, record) => sum + record.amount, 0));
  
  };
  const handleSearch = (searchText) => {
    let filtered = stockData;
    if (searchText.trim() !== "") {
     const lowerSearch = searchText.toLowerCase();
    filtered = filtered.filter(item =>
      Object.values(item).some(value => {
        // Handle nested objects (e.g. accountType.name)
        if (typeof value === "object" && value !== null) {
          return Object.values(value).some(nestedVal =>
            String(nestedVal).toLowerCase().includes(lowerSearch)
          );
        }
        return String(value).toLowerCase().includes(lowerSearch);
      })
    );
  }
    setFilteredData(filtered);
    setFooterTotal(filtered?.reduce((sum, record) => sum + record.amount, 0));
  };

  const handleReset = () => {
    setaccTypeFilter(null);
    setTypeFilter(null);
    setFromDate(dayjs());
    setToDate(dayjs());
    setSearchText("");
    setstockData(null);
    
  };
  const handleRefresh = () => {
    handleStockInfullReport();
    handleAccFilterChange();
    handleFilterChange();
    };
  return (
    <div className="ax-master ax-report">
      <LoadingUtils loading={loading} />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Pay In/Out Report</h4>
                <h6>Manage Pay In and Pay Out Report here</h6>
              </div>
            </div>

            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip("PDF")}>
                  <button
                    onClick={() =>
                      exportPDF(getActiveTabData, footerTotals, title)
                    }
                    disabled={loading}
                    className="btn btn-link bg-white rounded-lg border border-silver"
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="img"
                    />
                  </button>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Excel")}
                >
                  <button
                    onClick={() =>
                      exportExcel(getActiveTabData, footerTotals, title)
                    }
                    disabled={loading}
                    className="btn btn-link bg-white rounded-lg border border-silver"
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="excel-icon"
                    />
                  </button>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Print")}
                >
                  <button
                    onClick={() =>
                      printReport(getActiveTabData, footerTotals, title)
                    }
                    disabled={loading}
                    className="btn btn-link bg-white rounded-lg border border-silver"
                  >
                    <i data-feather="printer" className="feather-printer" />
                  </button>
                </OverlayTrigger>
              </li>
                <li>
                                            <OverlayTrigger
                                              placement="top"
                                              overlay={() => renderTooltip("Refresh")}
                                            >
                                              <Link onClick={handleRefresh}>
                                                <RotateCcw/>
                                              </Link>
                                            </OverlayTrigger>
                                          </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Collapse")}
                >
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={togglehead ? "active" : ""}
                    onClick={handletogglehead}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>

          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
               <div className="search-set">
                                <div className="search-input">
                                  <Link to="#" className="btn btn-searchset">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-search"
                                    >
                                      <circle cx={11} cy={11} r={8} />
                                      <line x1={21} y1={21} x2="16.65" y2="16.65" />
                                    </svg>
                                  </Link>
                                  <div
                                    id="DataTables_Table_0_filter"
                                    className="dataTables_filter"
                                  >
                                    <label>
                                      {" "}
                                      <input
                                        type="search"
                                        className="form-control form-control-sm"
                                        placeholder="Search"
                                        aria-controls="DataTables_Table_0"
                                        value={searchText}
                                        onChange={(e) => {
                                            setSearchText(e.target.value);
                                            handleSearch(e.target.value);}}
                                      />
                                    </label>
                                  </div>
                                </div>
                              </div>
                                   <div className="row">
                                <div className="col-md-6">
                                  <div className="input-blocks">
                                    <label htmlFor="from-date">From Date</label>
                                    <div className="input-groupicon calender-input">
                                      <Calendar className="info-img" />
                                      <DatePicker
                            className="datetimepicker"
                            id="from-date"
                            placeholderText="From Date"
                            // selected={fromDate}
                            value={fromDate}
                            onChange={handleFromDateChange}
                            startDate={fromDate}
                            selectsStart
                            allowClear
                            // dateFormat="dd/MM/yyyy"
                          />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="input-blocks mr-2">
                                    <label htmlFor="to-date">To Date</label>
                                    <div className="input-groupicon calender-input">
                                      <Calendar className="info-img" />
                                      <DatePicker
                            id="to-date"
                            placeholderText="To Date"
                            // selected={toDate}
                            value={toDate}
                            onChange={handleToDateChange}
                            minDate={fromDate}
                            startDate={fromDate}
                            selectsEnd
                            allowClear
                            disabled={!fromDate} // disable until from date is selected
                            // dateFormat="dd/MM/yyyy"
                            // className='form-control'
                          />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="d-flex justify-content-end mt-3">
                                <div className="input-blocks me-2">
                                <Link
                                        className="btn btn-filters ms-auto"
                                        onClick={() => {
                                          setCurrentPage(1);
                                          setPageSize(20);
                                          handleSearchbtn();
                                        }}
                                         disabled={!fromDate || !toDate}
                                      >
                                        <i data-feather="search" className="feather-search" />{" "}
                                        search{" "}
                                      </Link>
                                </div>
                                <div className="input-blocks">
                                  <button
                                    className="btn btn-reset rounded-2"
                                    onClick={handleReset}
                                  >
                                    <i data-feather="refresh-cw" className="feather-refresh-cw" /> Reset
                                  </button>
                                </div>
                              </div>
                <div className="search-path">
                  <Link
                    className={`btn btn-filter ${
                      isFilterVisible ? "setclose" : ""
                    }`}
                    onClick={toggleFilterVisibility}
                    id="filter_search"
                  >
                    <Filter className="filter-icon" />
                    <span>
                      <ImageWithBasePath
                        src="assets/img/icons/closes.svg"
                        alt="img"
                      />
                    </span>
                  </Link>
                </div>

                <div className="dropdown">
                  <button
                    className="btn  dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <Sliders className="info-img" />
                  </button>
                  <ul className="dropdown-menu p-2">
                    {menuItems
                      ?.filter((menu) => menu.label !== "Product")
                      .map((obj, i) => {
                        return (
                          <li key={i}>
                            <Checkbox
                              onChange={(e) =>
                                handleCheckboxChange(
                                  obj.value,
                                  e.target.checked
                                )
                              }
                              defaultChecked={obj.checked}
                            >
                              <div style={{ color: "black" }}> {obj.label}</div>
                            </Checkbox>
                          </li>
                        );
                      })}
                  </ul>
                </div>
              </div>

              <div
                className={`card${isFilterVisible ? " visible" : ""}`}
                id="filter_inputs"
                style={{ display: isFilterVisible ? "block" : "none" }}
              >
                <div className="card-body pb-0">
                  <div className="row">
                    <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <Select
                          className="img-select"
                          options={TypeFilter}
                          onChange={handleFilterChange}
                          value={typeFilter}
                          classNamePrefix="react-select"
                          placeholder="Type"
                          isClearable
                        />
                      </div>
                      
                    </div>
                    <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <Select
                          className="img-select"
                          options={AcctypeFilter}
                          onChange={handleAccFilterChange}
                          value={acctypeFilter}
                          classNamePrefix="react-select"
                          placeholder="Account Name"
                          isClearable
                        />
                      </div>
                    </div>
                  </div>
                  
                    
                  
                </div>
              </div>
              {/* /Filter */}
              {selectedColumns && (
                <div className="table-responsive product-list">
                  <Table
                    columns={selectedColumns}
                    dataSource={filteredData}
                    ref={tableRef}
                    id="table-to-export"
                    className="table datanew dataTable no-footer custom-table"
                    pagination={{
                      showTotal: (total, range) =>
                        `${range[0]}-${range[1]} of ${totalcount} items`,
                      current: currentPage,
                      pageSize: pageSize,
                      total: totalcount, // Total records count
                      onChange: (page, size) => {
                        setCurrentPage(page);
                        setPageSize(size);
                        handleStockInReport(page, size);
                        handleStockInfullReport();
                      },
                      showSizeChanger: true, // To enable page size selection dropdown
                      pageSizeOptions: ["10", "20", "50", "100"], // Different page size options
                    }}
                    summary={() => (
                      <Table.Summary.Row>
                        {selectedColumns?.map((col) => (
                          <Table.Summary.Cell key={col.dataIndex}>
                            <b> {col.dataIndex === "amount" ? footerTotals : ""}</b>
                          </Table.Summary.Cell>
                        ))}
                      </Table.Summary.Row>
                    )}
                  />
                </div>
              )}
            </div>
          </div>
          {/* /product list */}
        </div>
      </div>
    </div>
  );
};
export default PayInOutReport;
